module.exports = __webpack_public_path__ + "static/media/Classic S Guitar Match off VR.2671202.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic S Guitar Match off VR.mp3
// module id = M8Zg
// module chunks = 12